import { createPaginator } from "@smithy/core";
import { ListUsersCommand } from "../commands/ListUsersCommand";
import { RekognitionClient } from "../RekognitionClient";
export const paginateListUsers = createPaginator(RekognitionClient, ListUsersCommand, "NextToken", "NextToken", "MaxResults");
